'use client';

// Ctx
import useListListingCtx from "@src/context/list-listing-office-ctx";

const ListListingFilterJualBeli = () => {
  const { handleApply, params } = useListListingCtx()

  return (
    <div className="w-fit flex items-center p-0.5 bg-[#fff] rounded-md h-[40px]">
      <button onClick={() => handleApply("property-type", 1)} className={`h-full py-[3.5px] px-2 rounded-md text-15 ${+params.property_type_id === 1 ? "font-satoshi-bold bg-[#252526] text-white" : "font-satoshi"} min-w-[44px]`}>Beli</button>
      <button onClick={() => handleApply("property-type", 2)} className={`h-full rounded-md text-15 py-[3.5px] px-2 ${+params.property_type_id === 2 ? "font-satoshi-bold bg-[#252526] text-white" : "font-satoshi"}`}>Sewa</button>
    </div>
  )
}

export default ListListingFilterJualBeli
